import './homeView.sass';

import {AboutBlock, DiscussBlock, HeroBlock, SocialBlock, VideoBlock} from '../../components';
import {
    HeaderStore,
    HomeStore,
    SubscriptionStore
} from '../../stores';

import PropTypes from 'prop-types';
import React from 'react';
import {connectToStores} from 'epic-alt-utils/index';
import {withRouter} from 'react-router';

/**
 * HomePage View.
 */
@connectToStores
class HomeView extends React.Component {
    static getStores() {
        return [HomeStore, SubscriptionStore, HeaderStore];
    }

    static getPropsFromStores() {
        return {
            subscriptionStore: SubscriptionStore.getState(),
            homeStore: HomeStore.getState()
        };
    }

    static propTypes = {
        homeStore: PropTypes.object,
        subscriptionStore: PropTypes.object,
        mobile: PropTypes.bool,
        tablet: PropTypes.bool
    };

    render() {
        const CMSData = this.props.homeStore.cmsData;
        const {isSubscribed} = this.props.subscriptionStore;
        const {
            heroBlock,
            videoBlock,
            aboutBlock,
            discussBlock
        } = CMSData.homepage;
        return (
            <div className="homePage">
                <HeroBlock data={heroBlock} isSubscribed={isSubscribed} />
                <VideoBlock
                    bgImage={videoBlock.bgImage}
                    subTitle1={videoBlock.subTitle1}
                    title={videoBlock.title}
                    buttonText={videoBlock.buttonText}
                    videoId={videoBlock.videoID} />
                <AboutBlock
                    bgImage={aboutBlock.bgImage}
                    subTitle1={aboutBlock.subTitle1}
                    title={aboutBlock.title}
                    logo={aboutBlock.logo}
                    description={aboutBlock.description} />
                <SocialBlock socialLink={aboutBlock.socialLink} />
                <DiscussBlock
                    gunGirl={discussBlock.gunGirl}
                    bgImage={discussBlock.bgImage}
                    subTitle1={discussBlock.subTitle1}
                    title={discussBlock.title}
                    description={discussBlock.description}
                    buttonText1={discussBlock.buttonText1}
                    buttonLink1={discussBlock.buttonLink1} />
            </div>
        );
    }
}

export default withRouter(HomeView);
